import React, { useEffect, useState } from 'react'
import { Cookies, useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import PrivacyModal from '../modal/PrivacyModal';
import TermsModal from '../modal/TermsModal';

export default function RewardFooter() {

    const cookies = new Cookies();
    const navigate = useNavigate();
    const [checkTerms, setCheckTerms] = useState(false);
    const [checkPrivacy, setCheckPrivacy] = useState(false);

    const [checkTermsToogle, setCheckTermsToogle] = useState(false);
    const [checkPrivacyToogle, setCheckPrivacyToogle] = useState(false);
    const [userInfo, setuserInfoCookie] = useCookies(["user_details"]);

    const termsModalEvent = () => {
        setCheckTerms(true);
        setCheckTermsToogle(true);
    }
    const privacyModalEvent = () => {
        setCheckPrivacy(true);
        setCheckPrivacyToogle(true);
    }
    useEffect(() => {
        setCheckPrivacyToogle(false);
        setCheckTermsToogle(false);
    }, [])
    const logout = () => {
        cookies.remove("user_details", { path: "/" });
        navigate("/login");
    }

    return (
        <>
            <div className='RewardFooterBlock'>
                <div className='RewardFooterBlock_wrapper'>
                    <div className='footercontainer'> <span onClick={() => termsModalEvent()}>Terms & Conditions</span> | <span onClick={() => privacyModalEvent()}>Privacy Policy</span> Copyright@2023 </div>
                    {userInfo && userInfo.user_details && (window.location.href.includes("dashboard") || window.location.href.includes("my-account") || window.location.href.includes("change-password")) ?
                        // <button className='footerloginbtn' onClick={() => logout}>Logout</button>
                        ""
                        :
                        <button className='footerloginbtn' onClick={() => window.open('/login', '_blank')}>Login</button>
                    }
                </div>
            </div>
            {checkTerms ?
                <TermsModal page="health" popuptoogle={checkTermsToogle}
                    popuptooglefunc={setCheckTermsToogle} />
                : ""}
            {checkPrivacy ?
                <PrivacyModal page="health" popuptoogle={checkPrivacyToogle}
                    popuptooglefunc={setCheckPrivacyToogle} />
                : ""}
        </>
    )
}
